
import { fetchOrderSummaryDetails, updateOrderSummary } from "@/lib/order";
import { create } from "zustand"





interface IObj {
    [key: string]: any
}

type States = {
}
interface IResponse { status: boolean; data?: any; message?: string; error?: string }


type Actions = {
    updateUserOrderSummary:(doc?:{items:IObj[]})=>Promise<IResponse>
    userOrderSummaryDetails:()=>Promise<IResponse>
}

const useOrderStore = create<States & Actions>((set,get) => ({
 updateUserOrderSummary:async(doc?:{items:IObj[]})=>{
    const result = await updateOrderSummary(doc)
    return result
 },
 userOrderSummaryDetails:async()=>{
    const result = await fetchOrderSummaryDetails()
    return result
 }


}))


export default useOrderStore